<template>
  <v-expansion-panels
    v-model="panel"
    accordion
    flat
    class="other-saved-payment-methods mb-2"
    data-test="payment-methods-other-saved"
  >
    <v-expansion-panel class="other-saved-payment-methods__panel">
      <v-expansion-panel-header
        class="other-saved-payment-methods__panel-header text-subtitle-1 font-weight-semi-bold px-0 py-0"
      >
        {{ $t('fields.account.billing.payment.payment_methods_other_saved') }}
      </v-expansion-panel-header>
      <v-expansion-panel-content class="other-saved-payment-methods__panel-content px-0">
        <v-card outlined rounded class="other-saved-payment-methods__card">
          <PaymentMethodDetails
            v-for="method in methods"
            :key="method.id"
            :method="method"
            variant="row"
            :show-actions="isTeamLead"
            :is-setting-default="settingDefaultMethodId === method.id"
            :actions-disabled="actionsDisabled"
            :highlight="highlightedMethodId !== null && method.id === highlightedMethodId"
            class="other-saved-payment-methods__row px-4 min-width-0"
            @set-default="onSetDefault"
            @remove="onRemove"
          />
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script lang="ts">
import type { SavedPaymentMethod } from '@/classes/stripe';
import PaymentMethodDetails from '@/components/Subscription/PaymentMethodDetails.vue';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    PaymentMethodDetails,
  },
})
export default class OtherSavedPaymentMethods extends Vue {
  @Prop({ required: true })
  methods!: SavedPaymentMethod[];

  @Prop({ required: true })
  isTeamLead!: boolean;

  @Prop({ default: null })
  settingDefaultMethodId!: string | null;

  @Prop({ default: false })
  actionsDisabled!: boolean;

  @Prop({ default: null })
  highlightedMethodId!: string | null;

  @Prop({ default: null })
  value!: number | null;

  get panel(): number | null {
    return this.value;
  }

  set panel(panel: number | null) {
    this.$emit('input', panel);
  }

  @Emit('set-default')
  onSetDefault(method: SavedPaymentMethod): SavedPaymentMethod {
    return method;
  }

  @Emit('remove')
  onRemove(method: SavedPaymentMethod): SavedPaymentMethod {
    return method;
  }
}
</script>

<style lang="scss" scoped>
.other-saved-payment-methods {
  background-color: transparent;
}

.other-saved-payment-methods__panel {
  background-color: transparent !important;

  &::before {
    box-shadow: none;
  }
}

.other-saved-payment-methods__panel-header {
  min-height: rem(40) !important;
  color: map-get($lapis, 'base');

  ::v-deep .v-expansion-panel-header__icon {
    margin-left: rem(8);
  }
}

.other-saved-payment-methods__panel-content {
  ::v-deep .v-expansion-panel-content__wrap {
    padding: 0 0 rem(4);
  }
}

.other-saved-payment-methods__card {
  min-width: 0;
  max-height: rem(265);
  overflow-x: hidden;
  overflow-y: auto;
  // Firefox
  scrollbar-width: thin;
  scrollbar-color: map-get($neutral, 'lighten-1') transparent;
  // Chromium / Edge / Safari
  &::-webkit-scrollbar {
    width: rem(6);
  }
  &::-webkit-scrollbar-thumb {
    background-color: map-get($neutral, 'lighten-1');
    border-radius: rem(3);
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
}

.other-saved-payment-methods__row + .other-saved-payment-methods__row {
  border-top: 1px solid map-get($neutral, 'lighten-2');
}
</style>
